import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import { type IGridCellRendererParams } from "commonComponents/utilities/AgGridReact/AgGridReact.types";
import { DocumentContextMenu } from "commonComponents/utilities/DocumentContextMenu/DocumentContextMenu";

function columnFilesInternal(props: IGridCellRendererParams) {
    if (props.node.group) {
        return <>{props.value}</>;
    } else if (props.value) {
        return (
            <div className={cn("ag-col-files", props.className)}>
                <DocumentContextMenu {...props.value} />
            </div>
        );
    }
    return null;
}

export const columnFiles = memo(columnFilesInternal);
